// Set Timezone to Karachi (UTC+5) for timestamps

import { AbstractControl, FormControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function convertToKarachiTimestamp(timestampInput: string | Date): number {
  let date: Date;

  if (typeof timestampInput === 'string') {
    date = new Date(timestampInput);
  } else if (timestampInput instanceof Date) {
    date = timestampInput;
  } else {
    return;
  }

  const utcTimeStamp = date.getTime();
  const karachiOffsetMillis = 5 * 60 * 60 * 1000;
  return utcTimeStamp + karachiOffsetMillis;
}
export function noWhitespaceOrNumValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value || '';
    const trimmedValue = value.trim();

    // Check for leading whitespace
    const isWhitespace = value.length > 0 && value.trim().length === 0;

    // Check if the value (after trimming leading whitespace) consists only of numbers
    const isOnlyNumbers = /^[0-9]+$/.test(trimmedValue);

    // Combine both validations
    return isWhitespace || isOnlyNumbers ? { 'invalidInput': true } : null;
  };
}
export function usernameOrEmailValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  if (!value) return { required: true };

  const isEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value);
  const isUsername = /^[a-zA-Z0-9._-]{3,20}$/.test(value); // 3 to 20 chars, only letters, numbers, dots, underscores, dashes

  if (isEmail || isUsername) {
    return null; // ✅ valid
  }

  return { usernameOrEmail: true }; // ❌ invalid
}
// Add this helper method in the component class
export function pakistaniPhoneValidator(control: FormControl): { [key: string]: boolean } | null {
  if (!control.value) {
    return null;
  }

  // Remove spaces, dashes, and parentheses
  const cleanPhone = control.value.replace(/[\s\-()]/g, '');

  // Patterns for Pakistani numbers:
  // +923XXXXXXXXX (international)
  // 03XXXXXXXXX (local)
  // 923XXXXXXXXX (without plus)
  const patterns = [
    /^\+923[0-9]{9}$/, // +923XXXXXXXXX
    /^03[0-9]{9}$/,    // 03XXXXXXXXX
    /^923[0-9]{9}$/    // 923XXXXXXXXX
  ];

  const valid = patterns.some(pattern => pattern.test(cleanPhone));

  return valid ? null : { invalidPakistaniPhone: true };
}
// export function pakistaniPhoneValidator(control: FormControl): { [key: string]: boolean } | null {
//   if (!control.value) {
//     return null; // Don't validate if empty (handled by required validator)
//   }

//   const phoneRegex = /^(?:\+92|0)?3[0-9]{9}$/;
//   const valid = phoneRegex.test(control.value.replace(/[\s-]/g, ''));

//   return valid ? null : { invalidPakistaniPhone: true };
// }
export function isImageFile(file: File | any): boolean {
  if (file instanceof File) {
    return file.type.startsWith('image/');
  }

  if (file?.file_url) {
    return /\.(jpg|jpeg|png|gif|webp|svg)$/i.test(file.file_url);
  }

  return false;
}
export function isVideoFile(file: File | any): boolean {
  if (file instanceof File) {
    return file.type.startsWith('video/');
  }

  if (file?.file_url) {
    return /\.(mp4|webm|ogg|mov|avi|mkv)$/i.test(file.file_url);
  }

  return false;
}

export function isPdfFile(file: File | any): boolean {
  if (file instanceof File) {
    return file.type === 'application/pdf';
  }

  if (file?.file_url) {
    return /\.pdf$/i.test(file.file_url);
  }

  return false;
}
export function isWordFile(file: File | any): boolean {
  if (file instanceof File) {
    return (
      file.type === 'application/msword' ||
      file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    );
  }

  if (file?.file_url) {
    return /\.(doc|docx)$/i.test(file.file_url);
  }

  return false;
}
export function isExcelFile(file: File | any): boolean {
  if (file instanceof File) {
    return (
      file.type === 'application/vnd.ms-excel' ||
      file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    );
  }

  if (file?.file_url) {
    return /\.(xls|xlsx)$/i.test(file.file_url);
  }

  return false;
}
export function isTextFile(file: File | any): boolean {
  if (file instanceof File) {
    return file.type.startsWith('text/');
  }

  if (file?.file_url) {
    return /\.(txt|csv|log)$/i.test(file.file_url);
  }

  return false;
}
